import React from "react";
import { SVG, IconProps } from "../SVG";
export const SpotClock = ({
    spotColor = "#C9DBFE",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
}: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 40 40" {...props}>
        <g clipPath="url(#Clock_svg__a)">
            <path
                fill={spotColor}
                d="M4.004 21.355C2.19 26.793 2.278 34.178 9.023 35.65c.946.207 1.933.36 2.939.468 1.787 1.861 4.214 3.186 6.933 3.689 12.383 2.291 26.639-16.459 16.852-26.555C25.912 3.11 8.245 8.656 4.004 21.355Z"
            />
            <path
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={strokeWidth}
                d="m28.714 31.729 4.728 4.7m-4.728-4.7a13.411 13.411 0 0 0 4.728-10.236c0-5.836-3.72-10.804-8.919-12.661m4.19 22.897a13.388 13.388 0 0 1-8.712 3.206 13.388 13.388 0 0 1-8.716-3.208m0 0L6.56 36.428m4.727-4.701a13.412 13.412 0 0 1-4.727-10.234c0-5.836 3.72-10.804 8.92-12.661m-7.426 6.5a5.974 5.974 0 1 1 7.425-6.5m16.47 6.5a5.974 5.974 0 1 0-7.425-6.5m0 0a13.419 13.419 0 0 0-4.522-.78c-1.587 0-3.11.275-4.523.78m4.523 6.687v5.974l4.48 5.974"
            />
        </g>
        <defs>
            <clipPath id="Clock_svg__a">
                <path fill="#fff" d="M0 0h40v40H0z" />
            </clipPath>
        </defs>
    </SVG>
);
SpotClock.displayName = "SpotClock";
